export default __webpack_public_path__ + "static/media/ThankYouSharing.ba9bb748.png";